import { useState } from "react";
import { MATCHES } from "../../data/site";
import { useLang } from "../../i18n/LangContext";
import { SectionHead } from "./Brand";

const TABS = ["cricket", "football", "tennis"];

const Odd = ({ v, type, onClick, testid }) => (
  <button onClick={onClick} data-testid={testid}
    className={`w-16 rounded-md py-2 text-center text-sm font-semibold text-white transition-transform hover:-translate-y-0.5 ${type === "back" ? "bg-[#1E3A8A]/80 hover:bg-[#1E3A8A]" : "bg-[#831843]/80 hover:bg-[#831843]"}`}>
    {v}
  </button>
);

export const Exchange = ({ onJoin }) => {
  const [tab, setTab] = useState("cricket");
  const { exchange: t } = useLang().t;
  return (
    <section id="exchange" className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8">
      <SectionHead eyebrow={t.eyebrow} title={t.title} sub={t.sub} />
      <div className="glass-card overflow-hidden">
        <div className="flex gap-2 border-b border-[#D4AF37]/20 p-4">
          {TABS.map((k) => (
            <button key={k} onClick={() => setTab(k)} data-testid={`exchange-tab-${k}`}
              className={`rounded-full px-5 py-2 text-xs uppercase tracking-widest transition-colors ${tab === k ? "bg-[#D4AF37] text-black" : "text-zinc-400 hover:text-white"}`}>
              {t.tabs[k]}
            </button>
          ))}
        </div>
        <div className="divide-y divide-[#D4AF37]/10">
          {MATCHES[tab].map((m, i) => (
            <div key={m.teams} className="flex flex-col gap-4 p-5 md:flex-row md:items-center md:justify-between" data-testid={`exchange-row-${i}`}>
              <div>
                <div className="flex items-center gap-3">
                  {m.time === "LIVE" ? <span className="flex items-center gap-1.5 text-xs font-bold text-red-400"><span className="h-2 w-2 animate-pulse rounded-full bg-red-500" />{t.live}</span>
                    : <span className="text-xs text-zinc-500">{t.times?.[m.time] || m.time}</span>}
                  <span className="text-xs uppercase tracking-wider text-[#D4AF37]">{m.league}</span>
                </div>
                <p className="mt-1 font-serif text-lg text-white">{m.teams}</p>
              </div>
              <div className="flex gap-6">
                {[0, 1].map((k) => (
                  <div key={k} className="flex gap-1.5">
                    <Odd v={m.back[k]} type="back" onClick={onJoin} testid={`odd-back-${i}-${k}`} />
                    <Odd v={m.lay[k]} type="lay" onClick={onJoin} testid={`odd-lay-${i}-${k}`} />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <p className="border-t border-[#D4AF37]/10 px-5 py-3 text-xs text-zinc-500">{t.note}</p>
      </div>
    </section>
  );
};
